import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

import LoginMobile from "./LoginMobile.js";
import LoginTablet from "./LoginTablet.js";
import LoginDesktop from "./LoginDesktop.js";

import { isAuthenticated } from '../../utils/AuthorizationCheck';

const Home = ({auth}) => {
    
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new URLSearchParams();
            formData.append('email', email);
        
            const res = await axios.post('/auth/magic', formData.toString(), {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              withCredentials: true
            });
            //console.log(res);
            if (res.data.waitlisted) {
                window.location.href = '/no-access';
            } else if (res.data.sent) {
                // Redirect to check email page with context that this is from regular login
                window.location.href = '/check-your-email';
            } else {
                setStatus('Something unexpected happened.');
            }
          } catch (err) {
            console.error('Error sending magic link:', err);
            setStatus('Something went wrong. Please try again.');
          }
    };

    const handleGoogleAuth = () => {
        window.location.href = '/auth/google';
    };

    // If user is already authenticated, redirect to dashboard
    if (isAuthenticated(auth)) {
        return <Redirect to="/dashboard" />;
    }

    return (
        <>
            {/*MOBILE - xs, sm screens */}
            <div className="d-block d-md-none">                
                <LoginMobile 
                    handleSubmit={handleSubmit}
                    email={email}
                    setEmail={setEmail}
                    status={status}
                    onGoogleAuth={handleGoogleAuth}
                />                
            </div>

            {/*TABLET - md screens */}
            <div className="d-none d-md-block d-lg-none">      
                <LoginTablet 
                    handleSubmit={handleSubmit}
                    email={email}
                    setEmail={setEmail}
                    status={status}
                    onGoogleAuth={handleGoogleAuth}
                />
            </div>

            {/*DESKTOP - lg, xl screens */}
            <div className="d-none d-lg-block">                
                <LoginDesktop 
                    handleSubmit={handleSubmit}
                    email={email}
                    setEmail={setEmail}
                    status={status}
                    onGoogleAuth={handleGoogleAuth}
                />                
            </div>
        </>
    );
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Home);
